/**
 * 元数据和配置管理
 * 用于管理不同设备类型的元数据和配置信息
 */

import { DeviceType } from './deviceRedirect';
import { isWechat } from './mobile';

/**
 * 设备类型配置
 */
export const deviceConfig = {
  [DeviceType.MOBILE]: {
    // 移动端配置
    viewport: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
    themeColor: '#409EFF',
    title: '正企元数字科技 - 移动版',
    description: '正企元数字科技移动端官网，提供数字化转型全栈解决方案',
    keywords: '正企元,数字科技,移动端,数字化转型,解决方案'
  },
  [DeviceType.DESKTOP]: {
    // PC端配置
    viewport: 'width=device-width, initial-scale=1.0',
    themeColor: '#409EFF',
    title: '正企元数字科技 - 官方网站',
    description: '正企元数字科技官方网站，提供数字化转型全栈解决方案',
    keywords: '正企元,数字科技,官网,数字化转型,解决方案'
  }
};

/**
 * 根据设备类型获取配置
 * @param {string} deviceType 设备类型
 * @returns {object} 设备配置
 */
export const getDeviceConfig = (deviceType) => {
  return deviceConfig[deviceType] || deviceConfig[DeviceType.DESKTOP];
};

/**
 * 获取微信浏览器特定配置
 * @returns {object} 微信浏览器配置
 */
export const getWechatConfig = () => {
  return {
    viewport: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover',
    themeColor: '#409EFF',
    title: '正企元数字科技 - 微信版',
    description: '正企元数字科技微信版官网，提供数字化转型全栈解决方案',
    keywords: '正企元,数字科技,微信,数字化转型,解决方案'
  };
};

/**
 * 更新页面元数据
 * @param {string} deviceType 设备类型
 */
export const updatePageMeta = (deviceType) => {
  // 如果是微信浏览器，使用微信特定配置
  const config = isWechat() ? getWechatConfig() : getDeviceConfig(deviceType);
  
  // 更新标题
  document.title = config.title;
  
  // 更新视口
  let viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) {
    viewport = document.createElement('meta');
    viewport.name = 'viewport';
    document.head.appendChild(viewport);
  }
  viewport.content = config.viewport;
  
  // 更新主题色
  let themeColor = document.querySelector('meta[name="theme-color"]');
  if (!themeColor) {
    themeColor = document.createElement('meta');
    themeColor.name = 'theme-color';
    document.head.appendChild(themeColor);
  }
  themeColor.content = config.themeColor;
  
  // 更新描述
  let description = document.querySelector('meta[name="description"]');
  if (!description) {
    description = document.createElement('meta');
    description.name = 'description';
    document.head.appendChild(description);
  }
  description.content = config.description;
  
  // 更新关键词
  let keywords = document.querySelector('meta[name="keywords"]');
  if (!keywords) {
    keywords = document.createElement('meta');
    keywords.name = 'keywords';
    document.head.appendChild(keywords);
  }
  keywords.content = config.keywords;
};